import { defineStore } from 'pinia'
import FeatureFlagsApi from '~/api/FeatureFlagsApi'

interface FeatureFlagsState {
  flags: Record<string, boolean>
  loaded: boolean
}

export const useFeatureFlagsStore = defineStore('featureFlags', {
  state: (): FeatureFlagsState => ({
    flags: {},
    loaded: false,
  }),

  getters: {
    isEnabled:
      (state) =>
      (flag: string): boolean => {
        return state.flags[flag] === true
      },
  },

  actions: {
    async fetchFlags(): Promise<void> {
      try {
        this.flags = await FeatureFlagsApi.fetchFlags()
      } catch {
        this.flags = {}
      } finally {
        // One attempt per app session, success or not — mirrors the previous
        // fetch-once-at-boot behavior and avoids a retry on every navigation.
        this.loaded = true
      }
    },
  },
})
